import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { GridLoader } from "@/_components/loaders/GridLoader";

import makeStyles from "@mui/styles/makeStyles";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 0,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    width: 260,
    marginTop: -50,
    borderRadius: 0,
  },
  cardHeader: {
    fontSize: 20,
    marginTop: 55,
    fontWeight: 600,
  },
  divideMe: {
    marginTop: 10,
    marginBottom: 10,
  },
}));

const SaveOverlay = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { open, setOpen } = props;

  SaveOverlay.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="save-overlay"
      classes={{ paper: classes.dialogPaper }}
    >
      <Grid container direction="column">
        <Grid item>
          <Paper className={classes.paper} elevation={0}>
            <Grid container direction="column">
              <Grid item>
                <Typography className={classes.cardHeader}>
                  {t("toasts.saving")}
                </Typography>
              </Grid>
              <Divider className={classes.divideMe} />
              <Grid
                item
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <GridLoader />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default SaveOverlay;
